export default __webpack_public_path__ + "static/media/user-photo.c89aea28.jpg";